export default __webpack_public_path__ + "static/media/add-my-list-add.2294ee98.svg";